module.exports = __webpack_public_path__ + "static/media/205.0eace5cb.jpg";